query InternalExpensesList(
  $page: Int = 0
  $rowsPerPage: Int = 10
  $filter: InternalExpensesFilterInput
) {
  internalExpenses(page: $page, rowsPerPage: $rowsPerPage, filter: $filter) {
    nodes {
      id
      spentAt
      category
      title
      vendor
      amount {
        value
        currency
        valueUSD
      }
      note
      creatorId
      createdAt
      updatedAt
      deletedAt
      deleted
    }
    count
    totalAmount {
      value
      currency
      valueUSD
    }
  }
}
